// // src/pages/BlogDetail.jsx
// import React, { useEffect, useState } from "react";
// import { useParams, Link } from "react-router-dom";

// const BlogDetail = () => {
//   const { slug } = useParams();
//   const [blog, setBlog] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     if (!slug) return;
//     let mounted = true;

//     const fetchBlog = async () => {
//       try {
//         setLoading(true);
//         const res = await fetch(
//           `https://tyka.premierhostings.com/beta/api/site-blogs/${slug}`
//         );
//         const data = await res.json();
//         if (!mounted) return;

//         const blogData = data?.data || data;
//         setBlog(blogData);
//       } catch (err) {
//         console.error("Error loading blog:", err);
//         setError("Unable to load blog. Try again later.");
//       } finally {
//         if (mounted) setLoading(false);
//       }
//     };

//     fetchBlog();
//     return () => {
//       mounted = false;
//     };
//   }, [slug]);

//   if (loading) return <div className="p-6 text-center">Loading...</div>;
//   if (error) return <div className="p-6 text-center text-red-500">{error}</div>;
//   if (!blog) return <div className="p-6 text-center">No blog found.</div>;

//   const imageUrl =
//     blog?.image &&
//     (blog.image.startsWith("http") || blog.image.startsWith("//"))
//       ? blog.image
//       : blog?.image
//       ? `https://tyka.premierhostings.com/beta/storage/${blog.image}`
//       : null;

//   return (
//     <div className="max-w-4xl mx-auto py-12 px-4">
//       {/* Back button */}
//       <Link to="/" className="inline-block mb-4 text-sm underline">
//         ← Back
//       </Link>

//       {/* Title */}
//       <h1 className="text-3xl font-semibold mb-2">{blog.title}</h1>

//       {/* Excerpt */}
//       {blog.excerpt && (
//         <p className="text-gray-600 italic mb-4">{blog.excerpt}</p>
//       )}
//       {/* Main image */}
//       {imageUrl && (
//         <img
//           src={imageUrl}
//           alt={blog.title}
//           className="w-full h-auto mb-6 object-cover rounded"
//         />
//       )}

//       {/* Meta info */}
//       <div className="text-sm text-gray-500 mb-6">
//         <span>By {blog?.author?.name || "Unknown"}</span> ·{" "}
//         <span>{new Date(blog.created_at).toLocaleDateString()}</span>
//       </div>

//       {/* Full Body Content (with HTML + inline images) */}
//       <div
//         className="prose max-w-none dark:prose-invert"
//         dangerouslySetInnerHTML={{
//           __html: blog.body || "",
//         }}
//       />

//       {/* Extra Meta if available */}
//       <div className="mt-8 text-sm text-gray-500">
//         {blog.meta_description && (
//           <p>
//             <strong>Meta Description:</strong> {blog.meta_description}
//           </p>
//         )}
//         {blog.meta_keywords && (
//           <p>
//             <strong>Meta Keywords:</strong> {blog.meta_keywords}
//           </p>
//         )}
//         {/* <p>
//           <strong>Status:</strong> {blog.status}
//         </p> */}
//       </div>
//     </div>
//   );
// };

// export default BlogDetail;

// src/pages/BlogDetail.jsx
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";

const BlogDetail = () => {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Comment form state
  const [commentForm, setCommentForm] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [comments, setComments] = useState([]);
  const [posting, setPosting] = useState(false);

  const API_STORE_COMMENT =
    "https://tyka.premierhostings.com/beta/api/site-post-comment";
  const API_GET_COMMENT =
    "https://tyka.premierhostings.com/beta/api/site-post-comment";

  // Fetch blog data
  useEffect(() => {
    if (!slug) return;
    let mounted = true;

    const fetchBlog = async () => {
      try {
        setLoading(true);
        const res = await fetch(
          `https://tyka.premierhostings.com/beta/api/site-blogs/${slug}`
        );
        const data = await res.json();
        if (!mounted) return;

        const blogData = data?.data || data;
        setBlog(blogData);

        // Fetch comments for this blog by ID
        fetchComments(blogData.id);
      } catch (err) {
        console.error("Error loading blog:", err);
        setError("Unable to load blog. Try again later.");
      } finally {
        if (mounted) setLoading(false);
      }
    };

    fetchBlog();
    return () => {
      mounted = false;
    };
  }, [slug]);

  // Fetch comments for a post by ID
  const fetchComments = async (postId) => {
    if (!postId) return;
    try {
      const res = await axios.get(`${API_GET_COMMENT}/${postId}`);
      if (res.data?.data) {
        setComments(res.data.data);
      }
    } catch (err) {
      console.error("Error fetching comments:", err);
    }
  };

  // Handle form input
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCommentForm((prev) => ({ ...prev, [name]: value }));
  };

  // Handle comment post
  const handlePostComment = async (e) => {
    e.preventDefault();
    if (!commentForm.name || !commentForm.email || !commentForm.message) {
      alert("Please fill required fields.");
      return;
    }

    if (!blog?.id) return;

    setPosting(true);
    try {
      const payload = {
        post_id: blog.id,
        guest_name: commentForm.name,
        guest_email: commentForm.email,
        body: commentForm.message,
        subject: commentForm.subject || "",
      };

      const res = await axios.post(API_STORE_COMMENT, payload);

      if (res.data?.data) {
        // Add new comment at the top
        setComments((prev) => [res.data.data, ...prev]);
        setCommentForm({ name: "", email: "", subject: "", message: "" });

        Swal.fire({
          icon: "success",
          title: "Comment Posted!",
          text: "Your comment has been submitted successfully.",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed!",
          text: "Unable to post comment. Try again.",
        });
      }
    } catch (err) {
      console.error("Error posting comment:", err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to post comment. Try again.",
      });
    } finally {
      setPosting(false);
    }
  };

  if (loading) return <div className="p-6 text-center">Loading...</div>;
  if (error) return <div className="p-6 text-center text-red-500">{error}</div>;
  if (!blog) return <div className="p-6 text-center">No blog found.</div>;

  const imageUrl =
    blog?.image &&
    (blog.image.startsWith("http") || blog.image.startsWith("//"))
      ? blog.image
      : blog?.image
      ? `https://tyka.premierhostings.com/beta/storage/${blog.image}`
      : null;

  return (
    <div className="max-w-4xl mx-auto py-12 px-4">
      {/* Back button */}
      <Link to="/" className="inline-block mb-4 text-sm underline">
        ← Back
      </Link>

      {/* Title */}
      <h1 className="text-3xl font-semibold mb-2">{blog.title}</h1>

      {/* Excerpt */}
      {blog.excerpt && (
        <p className="text-gray-600 italic mb-4">{blog.excerpt}</p>
      )}

      {/* Main image */}
      {/* {imageUrl && (
        <img
          src={imageUrl}
          alt={blog.title}
          className="w-full h-auto mb-6 object-cover rounded"
        />
      )} */}

      {/* Meta info */}
      <div className="text-sm text-gray-500 mb-6">
        <span>By {blog?.author?.name || "Unknown"}</span> ·{" "}
        <span>{new Date(blog.created_at).toLocaleDateString()}</span>
      </div>

      {/* Full Body Content */}
      <div
        className="prose max-w-none dark:prose-invert"
        dangerouslySetInnerHTML={{ __html: blog.body || "" }}
      />

      {/* Extra Meta if available */}
      <div className="mt-8 text-sm text-gray-500">
        {blog.meta_description && (
          <p>
            <strong>Meta Description:</strong> {blog.meta_description}
          </p>
        )}
        {blog.meta_keywords && (
          <p>
            <strong>Meta Keywords:</strong> {blog.meta_keywords}
          </p>
        )}
      </div>

      {/* ---------------- COMMENT SECTION ---------------- */}
      <div className="mt-12 border-t pt-8">
        <h2 className="text-xl font-bold mb-4">Leave a Comment</h2>

        <form onSubmit={handlePostComment} className="space-y-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <input
              type="text"
              name="name"
              value={commentForm.name}
              onChange={handleInputChange}
              placeholder="Name *"
              className="w-full p-2 border rounded"
              required
            />
            <input
              type="email"
              name="email"
              value={commentForm.email}
              onChange={handleInputChange}
              placeholder="Email *"
              className="w-full p-2 border rounded"
              required
            />
          </div>
          <input
            type="text"
            name="subject"
            value={commentForm.subject}
            onChange={handleInputChange}
            placeholder="Subject (optional)"
            className="w-full p-2 border rounded"
          />
          <textarea
            name="message"
            value={commentForm.message}
            onChange={handleInputChange}
            placeholder="Message"
            rows="5"
            className="w-full p-2 border rounded"
            required
          />
          <button
            type="submit"
            disabled={posting}
            className="bg-gray-700 text-white px-4 py-2 rounded hover:bg-gray-800"
          >
            {posting ? "Posting..." : "Post Comment"}
          </button>
        </form>

        {/* Comment List */}
        <div className="mt-8">
          <h3 className="font-bold mb-2">({comments.length}) Comments</h3>
          {comments.length === 0 ? (
            <p className="text-gray-500">No comments yet.</p>
          ) : (
            <ul className="space-y-4">
              {comments.map((c) => (
                <li key={c.id} className="border p-3 rounded">
                  {c.subject && (
                    <p className="text-sm italic">Subject: {c.subject}</p>
                  )}
                  <p className="mt-2">{c.body}</p>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
      {/* ------------------------------------------------- */}
    </div>
  );
};

export default BlogDetail;
